<template>
  <div class="configPage">
    <el-form :model="SearchForm" inline>
      <el-form-item :label="$t('public.time')">
        <el-date-picker
          v-model="time"
          type="datetimerange"
          :start-placeholder="$t('public.start_date')"
          :end-placeholder="$t('public.end_date')"
          @change="changeTime"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-button icon="el-icon-refresh" @click="reastFn"></el-button>
      <el-button icon="el-icon-search" @click="searchFn"></el-button>
    </el-form>
    <div class="searchContent">
      <div
        v-for="item in SearchArray"
        :key="item.key"
        style="margin-right: 15px;"
      >
        <span class="searchName">{{ $t(item.name) }}</span>
        <span class="searchValue">{{ item.value }}</span>
      </div>
    </div>
    <div class="tablePage">
      <el-table
        stripe
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :height="tableHeight"
        row-key="id"
        :show-header="false"
        :tree-props="{
          children: 'responseDeviceConfigLogList',
          hasChildren: 'hasChildren'
        }"
      >
        <el-table-column
          prop="createTime"
          :label="$t('public.time')"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span>{{ $timetransition(row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('integration.command_form')"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span class="lineHeight40">{{ filterType(row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="step"
          :label="$t('integration.current_step')"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span>{{ $t(row.stepCode
                ? configStep[row.stepCode].title
                : configStatusConvert(row.status).title) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operate"
          :label="$t('public.table_operation')"
          width="120px"
        >
          <template #default="{ row }">
            <el-button
              type="text"
              icon="el-icon-tickets"
              :title="$t('public.details')"
              @click="detailFn(row)"
            ></el-button>
            <el-button
              type="text"
              v-show="row.responseDeviceConfigLogList"
              icon="el-icon-delete"
              :title="$t('public.tbopt_delete')"
              @click="delFn(row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        class="pagination"
        :total="total"
        :page.sync="SearchForm.startRecord"
        :limit.sync="SearchForm.maxRecords"
        @pagination="getList"
      ></Pagination>
    </div>
    <!-- </section> -->
    <CmdDialog
      v-bind="$attrs"
      :isShow.sync="isShow"
      :cmdObj="cmdObj"
      :title="title"
      ref="configLogDia"
    />
  </div>
</template>

<script>
import {
  delConifg,
  getConfigContent,
  getConfigLogContent,
  getConfiglogList
} from '@/api/modules/deviceUrl.js'
import CmdDialog from './children/CmdDialog.vue'
import { configStatusConvert, configStep } from '@/utils/convert'
import { ENUM_RE_SENSOR_CONFIG_TYPE } from '@/common/enum/reverse/device'
import { sensorTypeConvert } from '@/utils/dict/sensor'

export default {
  computed: {
    configStep () {
      return configStep
    }
  },
  props: ['rowData'],
  filters: {
    filterTypes (type) {
      return this.$t(sensorTypeConvert(type).title)
    }
  },
  components: {
    CmdDialog
  },
  data () {
    return {
      SearchForm: {
        devId: '',
        devType: 0, // 设备目录 0-传感器,1-网关,2-显示屏,3-中继
        startTime: '',
        endTime: '',
        startRecord: 0,
        maxRecords: 15
      },
      total: 0,
      time: [],
      tableHeight: '400px',
      tableData: [],
      SearchArray: [
        {
          key: 'tagId',
          name: 'device.sensor_code',
          value: ''
        }
      ],
      isShow: false,
      title: '',
      cmdObj: ''
    }
  },
  mounted () {
    this.SearchArray[0].value = this.rowData.tagId
    this.getList()
  },
  methods: {
    configStatusConvert,
    searchFn () {
      this.getList()
    },
    reastFn () {
      if (this.SearchArray.length > 1) {
        this.SearchArray.pop()
      }
      ;(this.SearchForm = {
        devId: '',
        devType: 0, // 设备目录 0-传感器,1-网关,2-显示屏,3-中继
        startTime: '',
        endTime: '',
        startRecord: 0,
        maxRecords: 15
      }),
      (this.time = [])
      this.getList()
    },
    changeTime (time) {
      this.SearchForm.startTime = this.$dateParseTime(new Date(time[0]))
      this.SearchForm.endTime = this.$dateParseTime(new Date(time[1]))
      this.SearchArray[1].value = time[0] + '-' + time[1]
      console.log(this.SearchArray)
    },
    getList () {
      this.SearchForm.devId = this.rowData.id
      getConfiglogList(this.SearchForm, 'sensor').then(({ result, state }) => {
        if (state.code === 200) {
          if (result.page && result.page.result.length > 0) {
            this.tableData = result.page.result
            this.total = result.page.pageInfo.total
            this.time = [
              this.$timetransition(result.startTime),
              this.$timetransition(result.endTime)
            ]
            if (!this.SearchArray[1]) {
              this.SearchArray.push({
                key: 'time',
                name: $t('public.time'),
                value:
                  this.$timetransition(result.startTime) +
                  '-' +
                  this.$timetransition(result.endTime)
              })
              this.SearchForm.startTime = result.startTime
              this.SearchForm.endTime = result.endTime
            }
          } else {
            this.tableData = []
            this.total = 0
          }
        }
      })
    },

    filterType (type) {
      if (!type) return '--'
      return this.$t(ENUM_RE_SENSOR_CONFIG_TYPE[type].title)
    },
    // 删除
    delFn (row) {
      this.$confirm(
        this.$t('messageTitle.DeleteToContinue'),
        this.$t('public.prompt'),
        {
          confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
          cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
          type: 'warning'
        }
      )
        .then(() => {
          delConifg({ configId: row.id }, 'sensor').then(({ state }) => {
            if (state.code === 200) {
              this.$message.success($t('integration.successfully_deleted'))
              this.getList()
            }
          })
        })
        .catch(() => {})
    },

    detailFn (row) {
      this.isShow = true
      this.title = `[${row.deviceName}][${
        row.type === 'app'
          ? $t('public.escalation_rules')
          : $t('public.net_param')
      }]${$t($t('integration.configuration_details'))}[${this.$timetransition(
        row.createTime
      )}]`
      if (this.rowData.type >= 7) {
        this.$refs.configLogDia.open(this.rowData, row)
      } else {
        let param = ''
        let httpUrl = ''
        row.responseDeviceConfigLogList
          ? (param = 'configId')
          : (param = 'configLogId')
        row.responseDeviceConfigLogList
          ? (httpUrl = getConfigContent)
          : (httpUrl = getConfigLogContent)
        const query = {
          [param]: row.id
        }
        httpUrl(query, 'sensor').then(({ result }) => {
          if (result) {
            // content  Json化
            let url = this.rowData.scopeName
            if (this.rowData.sceneName) {
              url += '/' + this.rowData.sceneName
            }
            if (this.rowData.carrierName) {
              url += '/' + this.rowData.carrierName
            }
            if (param === 'configId') {
              const JsonContent = result.deviceConfig ? JSON.parse(result.deviceConfig.content) : {}
              this.cmdObj = {
                fullPath: url,
                deviceName: this.rowData.tagId,
                carrierName: this.rowData.carrierName,
                deviceType: this.rowData.type,
                configStatus: this.rowData.configStatus,
                status: this.rowData.status,
                description: this.rowData.description,
                step: result.stepCode,
                type: row.type,
                // 从外层获取详细
                // content 内容
                cmd: JsonContent.cmd,

                ...JsonContent.item
              }
            } else {
              const JsonContent = JSON.parse(result.content)
              let childrenContent = ''
              if (JsonContent.content) {
                childrenContent = JSON.parse(JsonContent.content)
              }
              this.cmdObj = {
                fullPath: url,
                deviceName: JsonContent.deviceName,
                deviceType: JsonContent.deviceType,
                status: JsonContent.status,
                step: result.stepCode,
                type: JsonContent.type,
                // 从外层获取详细
                carrierName: this.rowData.carrierName,
                description: this.rowData.description,
                configStatus: this.rowData.configStatus,
                // content 内容
                cmd: childrenContent.cmd,

                ...childrenContent.item
              }
            }
          } else {
            this.cmdObj = {}
          }
        })
      }

      // let JsonContent = '';
      // let deviceType,step;
      // if (row.content) {
      //     deviceType = JSON.parse(row.content).deviceType
      //     JsonContent = JSON.parse(row.content);
      //     if (JsonContent.content) {
      //         step = row.stepCode
      //         JsonContent = JSON.parse(JsonContent.content)
      //     }
      // }
      // const { cmd, item } = JsonContent;
      // this.cmdObj = {
      //     fullPath: row['fullPath'],
      //     deviceName: row['deviceName'],
      //     carrierName: this.rowData['carrierName'],
      //     deviceType: deviceType || row.deviceType,
      //     typeWay: row['type'],
      //     cmd,
      //     ...item,
      //     step,
      // };
      // this.isShow = true;
      // this.title = `[${row.deviceName}][${row.type === 'app' ? 'public.escalation_rules' : 'public.net_param'}]配置详情[${this.$timetransition(row.createTime)}]`
    }
  }
}
</script>

<style lang="scss" scoped>
.configPage {
  margin-top: 15px;

  ::v-deep .el-button {
    background-color: #fff !important;
    margin-right: 0;

    i {
      color: var(--primary-color);
    }
  }

  .searchContent {
    height: 50px;
    width: 100%;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-radius: 2px;
    line-height: 50px;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 15px;
  }

  .tablePage {
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding: 15px;
    min-height: 300px;
  }

  .searchName,
  .searchValue {
    background-color: var(--primary-color);
    padding: 5px;
    border-radius: 2px;
    color: #fff;
  }

  .searchValue {
    background-color: #fff;
    border: 1px solid #ccc;
    color: var(--primary-color);
    border-left: none;
    border-radius: 2px;
  }

  .lineHeight40 {
    line-height: 40px;
  }

  .pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
